function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { BaseAuthHandler } from './base';
import { // GetUserResult, // 현재 미사용으로 주석 처리
TOKEN_KEY, USER_KEY } from '../types';
import { tokenManager } from '../token-manager';
export var SimpleVsCodeAuthHandler = /*#__PURE__*/ function(BaseAuthHandler) {
    "use strict";
    _inherits(SimpleVsCodeAuthHandler, BaseAuthHandler);
    function SimpleVsCodeAuthHandler(authServerUrl, ideMessenger) {
        _class_call_check(this, SimpleVsCodeAuthHandler);
        var _this;
        _this = _call_super(this, SimpleVsCodeAuthHandler, [
            authServerUrl || 'http://authserver.local'
        ]), _define_property(_this, "ideMessenger", null);
        if (ideMessenger) {
            _this.setIdeMessenger(ideMessenger);
        }
        return _this;
    }
    _create_class(SimpleVsCodeAuthHandler, [
        {
            key: "setIdeMessenger",
            value: function setIdeMessenger(ideMessenger) {
                this.ideMessenger = ideMessenger;
            }
        },
        {
            key: "initialize",
            value: function initialize(setState) {
                var _this = this;
                return _async_to_generator(function() {
                    var token, storedUserJson, user, isAuthenticated, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log('[SimpleVsCodeAuthHandler] Initializing...');
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.refreshAuthState(setState)
                                ];
                            case 2:
                                _state.sent();
                                token = localStorage.getItem(TOKEN_KEY);
                                storedUserJson = localStorage.getItem(USER_KEY);
                                user = null;
                                if (storedUserJson) {
                                    try {
                                        user = JSON.parse(storedUserJson);
                                    } catch (e) {
                                        console.error('[SimpleVsCodeAuthHandler] Failed to parse stored user:', e);
                                    }
                                }
                                isAuthenticated = !!token;
                                return [
                                    2,
                                    {
                                        isAuthenticated: isAuthenticated,
                                        user: user,
                                        token: token
                                    }
                                ];
                            case 3:
                                error = _state.sent();
                                console.error('[SimpleVsCodeAuthHandler] Initialization failed:', error);
                                setState(function() {
                                    return {
                                        user: null,
                                        token: null,
                                        isAuthenticated: false
                                    };
                                });
                                return [
                                    2,
                                    {
                                        isAuthenticated: false,
                                        user: null,
                                        token: null
                                    }
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkAuthStatus",
            value: function checkAuthStatus(setState) {
                return _async_to_generator(function() {
                    var token, isAuthenticated;
                    return _ts_generator(this, function(_state) {
                        console.log('[SimpleVsCodeAuthHandler] Checking auth status...');
                        token = localStorage.getItem(TOKEN_KEY);
                        isAuthenticated = !!token;
                        setState(function(current) {
                            return _object_spread_props(_object_spread({}, current), {
                                isAuthenticated: isAuthenticated,
                                token: token
                            });
                        });
                        return [
                            2,
                            isAuthenticated
                        ];
                    });
                })();
            }
        },
        {
            key: "refreshAuthState",
            value: function refreshAuthState(setState) {
                var _this = this;
                return _async_to_generator(function() {
                    var authResponse, user, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log('[SimpleVsCodeAuthHandler] Refreshing auth state...');
                                if (!_this.ideMessenger) {
                                    console.warn('[SimpleVsCodeAuthHandler] No IDE messenger available');
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.ideMessenger.request('getControlPlaneSessionInfo', {
                                        silent: true
                                    })
                                ];
                            case 2:
                                authResponse = _state.sent();
                                if (!(authResponse === null || authResponse === void 0 ? void 0 : authResponse.accessToken)) return [
                                    3,
                                    4
                                ];
                                // 토큰 설정
                                tokenManager.setToken(authResponse.accessToken);
                                return [
                                    4,
                                    _this.loadUserProfile(authResponse)
                                ];
                            case 3:
                                user = _state.sent();
                                setState(function() {
                                    return {
                                        isAuthenticated: true,
                                        user: user,
                                        token: authResponse.accessToken
                                    };
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                // 인증되지 않은 상태
                                _this.clearAuthState(setState);
                                _state.label = 5;
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                error = _state.sent();
                                console.error('[SimpleVsCodeAuthHandler] Auth state refresh failed:', error);
                                _this.clearAuthState(setState);
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadUserProfile",
            value: function loadUserProfile(authResponse) {
                var _this = this;
                return _async_to_generator(function() {
                    var _authResponse_account, _authResponse_account1, userId, username, profileResponse, _profileResponse_data, uuidError, profileData, user, user1, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    12,
                                    ,
                                    13
                                ]);
                                userId = (_authResponse_account = authResponse.account) === null || _authResponse_account === void 0 ? void 0 : _authResponse_account.id;
                                username = (_authResponse_account1 = authResponse.account) === null || _authResponse_account1 === void 0 ? void 0 : _authResponse_account1.label;
                                if (!userId && !username) {
                                    throw new Error('No user ID or username available.');
                                }
                                if (!(_this.apiService && _this.apiService.userApi)) return [
                                    3,
                                    11
                                ];
                                if (!userId) return [
                                    3,
                                    8
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.apiService.userApi.getProfileByUuid({
                                        uuid: userId
                                    })
                                ];
                            case 2:
                                profileResponse = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                uuidError = _state.sent();
                                if (!username) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _this.apiService.userApi.getProfileByUsername({
                                        username: username
                                    })
                                ];
                            case 4:
                                profileResponse = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw uuidError;
                            case 6:
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                if (!username) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _this.apiService.userApi.getProfileByUsername({
                                        username: username
                                    })
                                ];
                            case 9:
                                profileResponse = _state.sent();
                                _state.label = 10;
                            case 10:
                                if (profileResponse === null || profileResponse === void 0 ? void 0 : (_profileResponse_data = profileResponse.data) === null || _profileResponse_data === void 0 ? void 0 : _profileResponse_data.basicInfo) {
                                    profileData = profileResponse.data;
                                    user = {
                                        id: profileData.basicInfo.id,
                                        username: profileData.basicInfo.username,
                                        name: profileData.basicInfo.displayName,
                                        profileImage: profileData.basicInfo.profileImageUrl
                                    };
                                    localStorage.setItem(USER_KEY, JSON.stringify(user));
                                    return [
                                        2,
                                        user
                                    ];
                                }
                                _state.label = 11;
                            case 11:
                                // Fallback: create user from auth response
                                if (userId && username) {
                                    user1 = {
                                        id: userId,
                                        username: username,
                                        name: username
                                    };
                                    localStorage.setItem(USER_KEY, JSON.stringify(user1));
                                    return [
                                        2,
                                        user1
                                    ];
                                }
                                throw new Error('Invalid profile data');
                            case 12:
                                error = _state.sent();
                                console.error('[SimpleVsCodeAuthHandler] User profile load failed:', error);
                                return [
                                    2,
                                    null
                                ];
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleTokenRefresh",
            value: function handleTokenRefresh(setState) {
                var _this = this;
                return _async_to_generator(function() {
                    var token, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log('[SimpleVsCodeAuthHandler] Attempting token refresh...');
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.refreshAuthState(setState)
                                ];
                            case 2:
                                _state.sent();
                                token = localStorage.getItem(TOKEN_KEY);
                                return [
                                    2,
                                    !!token
                                ];
                            case 3:
                                error = _state.sent();
                                console.error('[SimpleVsCodeAuthHandler] Token refresh failed:', error);
                                return [
                                    4,
                                    _this.logout(setState)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "logout",
            value: function logout(setState) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        console.log('[SimpleVsCodeAuthHandler] Logging out...');
                        _this.clearAuthState(setState);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "clearAuthState",
            value: function clearAuthState(setState) {
                this.clearAuthStorage();
                setState(function() {
                    return {
                        isAuthenticated: false,
                        user: null,
                        token: null
                    };
                });
            }
        }
    ]);
    return SimpleVsCodeAuthHandler;
}(BaseAuthHandler);
